import { FC } from "react";
import { useAppStore } from "@/store";
import { SettingsTabId } from "@/store/pages/SettingsPageStore/types";
import { observer } from "mobx-react-lite";
import { CalendarDisconnectedContentView } from "./calendar-disconnected-content.view";

export const CalendarDisconnectedContent: FC = observer(() => {
  const { store } = useAppStore();

  const handleClick = () => {
    store.settingsModal.open(SettingsTabId.CalendarAndMeetingsPage);
  };

  return <CalendarDisconnectedContentView onClick={handleClick} />;
});
